<template>
    <div>
        <div class="card shadow mb-4">
            <div class="card-header py-3">
                <h3 class="m-0 font-weight-bold text-primary mb-2">Steps for Category {{currentCategory.title}}
                    <router-link :to="'/admin/categories/' + this.$route.params.categoryId + '/steps/add'" class="btn btn-primary float-right w-auto ml-2"><icon icon="plus-circle" /> Add New Category Step</router-link>
                    <router-link :to="'/admin/categories/' + this.$route.params.categoryId + '/steps/reorder/' " class="btn btn-primary float-right ml-2"><icon icon="arrows-alt" /> Reorder Category Steps</router-link>
                </h3>
                </div>
            <div v-if="deleteResponse.success != null" v-bind:class="{ 'alert-success': deleteResponse.success, 'alert-danger': !deleteResponse.success }" class="alert" role="alert">
                {{deleteResponse.message}}
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <b-table show-empty
                             striped
                             :items="categorySteps"
                             :fields="fields">
                        <template v-slot:cell(title)="row">
                            {{ row.item.title }}
                        </template>
                        <template v-slot:cell(treatment)="row">
                            <icon v-if="row.item.treatment === true" icon="check" />
                        </template>
                        <template v-slot:cell(isLast)="row">
                            <icon v-if="row.item.isLast === true" icon="check" />
                        </template>
                        <template v-slot:cell(questionnaire)="row">
                            <router-link v-if="row.item.questionnaireId" :to="`/admin/questionnaires/${row.item.questionnaireId}`" class="btn btn-warning">Questionnaire</router-link>
                            <router-link v-else :to="`/admin/questionnaires/add?category=${categoryId}&step=${row.item.id}`" class="btn btn-warning">Add Questionnaire</router-link>
                        </template>
                        <template v-slot:cell(modify)="row">
                            <router-link :to="`/admin/categories/${categoryId}/steps/${row.item.id}/edit/`" class="btn btn-warning">Modify</router-link>
                        </template>
                        <template v-slot:cell(delete)="row">
                            <button @click="enableDeleteModal(row.item)" class="btn btn-danger">Delete</button>
                        </template>
                    </b-table>
                </div>
                <b-pagination-nav 
                    v-model="currentPage" 
                    :link-gen="linkGeneration" 
                    :number-of-pages="totalPages" 
                    use-router 
                    :first-text="this.$t('PAGING_FIRST_PAGE')"
                    :last-text="this.$t('PAGING_LAST_PAGE')" 
                    align="center">
                </b-pagination-nav>
            </div>
        </div>
        <modal :title="modalTitle" :body="modalBody" :button="modalButtonText" @action="deleteCategoryStep(modalCategoryStepId)" v-if="showModal" @close="showModal = false"></modal>
    </div>
</template>

<script>
import Modal from './../../misc/Modal.vue';
import { PAGE_SIZE } from './../../../globalConstants';
import pagingMixin from './../../../mixins/pagingMixin';

export default {
    mixins: [ pagingMixin ],
    components: {
        modal: Modal
    },
    data() {
        return {
            currentCategory: {},
            categoryId: null,
            categorySteps: [],
            currentPage: null,
            totalCategorySteps: 0,
            totalPages: 1,
            fields: [
                { key: 'title', label: 'Title', sortable: true },
                { key: 'treatment', label: 'Treatment', sortable: true },
                { key: 'isLast', label: 'Is Last', sortable: true },
                { key: 'questionnaire', label: 'Questionnaire', tdClass: 'fit' },
                { key: 'modify', label: 'Modify', tdClass: 'fit' },
                { key: 'delete', label: 'Delete', tdClass: 'fit' }
            ],
            deleteResponse: {},
            modalBody: null,
            modalTitle: "Delete Confirmation",
            modalButtonText: "Delete",
            showModal: false,
            modalCategoryStepId: null
        }
    },
    methods: {
        enableDeleteModal: function(categoryStep){
            this.modalBody = `Select 'Delete' below if you are sure you want to delete the Category Step ${categoryStep.title}`;
            this.modalCategoryStepId = categoryStep.id;
            this.showModal = true;
        },
        deleteCategoryStep: function(categoryStepId) {
            let self = this;
            this.$http.delete('/api/category-steps/delete/' + categoryStepId)
            .then(response => {
                var localDeleteResponse = response.data;
                localDeleteResponse.id = categoryStepId;
                self.deleteResponse = localDeleteResponse;
                
            })
            .catch(error => {
                console.log(error);
            })
        },
        loadCategorySteps: function() {
            this.$http
                .get('/api/category-steps/get-all-per-category-on-page/' + this.$route.params.categoryId + '?p=' + this.currentPage)
                .then(response => {
                    if (this.categorySteps.length == 0) {
                        this.loadTotalCategoryStepsCount();
                    }
                    this.categorySteps = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
        },
        loadTotalCategoryStepsCount: function () {
            this.$http
                .get('/api/category-steps/count/' + this.$route.params.categoryId)
                .then(response => {
                    this.totalCategorySteps = response.data;
                    this.totalPages = this.calculateNumberOfPages(this.totalCategorySteps);
                })
                .catch(error => {
                    console.log(error);
                })
        },
        loadCurrentCategory: function() {
            let self = this;
            this.$http.get('/api/categories/get/' + this.$route.params.categoryId)
            .then(response => {
                self.currentCategory = response.data;
                
            })
            .catch(error => {
                console.log(error);
                self.$router.push("/404");
            })
        },
        linkGeneration: function(pageNumber) {
            return {
                path: `/admin/categories/${ this.categoryId }/steps`,
                query: { p: pageNumber }
            }
        }
    },
    created: function () {
        this.loadCurrentCategory();
        this.categoryId = this.$route.params.categoryId;
        this.currentPage = this.$route.query.p ? Number(this.$route.query.p) : 1;
    },
    watch: {
        deleteResponse: function(val) {
            if (val.success === true) {
                // get index of object with id: val.id
                var removeIndex = this.categorySteps.map(function(item) { return item.id; }).indexOf(val.id);
                // remove object
                this.categorySteps.splice(removeIndex, 1);
            }
            setTimeout(() => {this.deleteResponse.success = null}, 3000)
        },
        currentPage: function(val) {
            this.loadCategorySteps();
        }
    }
}
</script>

<style lang="scss" scoped>

</style>